import React, { useEffect, useRef, useState } from "react";
import doxzonLogo from "../assets/logo/Doxzon LogoNew.svg";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { FaBars, FaShoppingCart, FaTimes } from "react-icons/fa";
import { Avatar, Badge, Drawer, Dropdown, Menu, Modal, Tooltip } from "antd";
import { APP_ROUTES } from "../PageRouting/pageRoutes";
import Login from "../Authentication/Login";
import { GiHealing } from "react-icons/gi";
import { MdContactEmergency } from "react-icons/md";
import EmergencyDataView from "./EmergencyDataView";
import { IoIosChatboxes, IoIosNotifications } from "react-icons/io";
import LiveChat from "../Pages/LiveChat";
import { countUnreadMessages } from "../Services/chatService";
import { useDispatch, useSelector } from "react-redux";
import { GETCOUNT } from "../Redux/actions/ChatActions";
import SignUp from "../Authentication/SignUp";
import {
  handleLoginSignUpModal,
  LOGINMODAL,
  SIGNUPMODAL,
} from "../Redux/actions/commonActions";
import { getNotificationCount } from "../Redux/actions/NotificationActions";
import { clearLoggedUser, deleteDataFromLocal } from "../Redux/actions/AuthActions";
import MembershipSlider from "./MembershipSlider";
import { clearSelectedAppt } from "../Redux/actions/appointmentActions";

function Navbar() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);
  const [showsideMenuDropdown, setShowsideMenuDropdown] = useState(false);
  const [emgDataModal, setEmgDataModal] = useState(false);
  const [chatOpen, setChatOpen] = useState(false);
  const sideMenudropdownRef = useRef(null);
  const headerdropdownRef = useRef(null);
  const navigate = useNavigate();
  const location = useLocation();
  const loggedUserJson = localStorage.getItem("patientData");
  const loggedUser = loggedUserJson ? JSON.parse(loggedUserJson) : null;
  const dispatch = useDispatch();
  const { selectedType, regModal, loginModal } = useSelector(
    (state) => state.common
  );
  const totalnotifyCount = useSelector((state) => state.chatCount.count);
  const notificationCount = useSelector(
    (state) => state.notificationCount.count
  );
  const { cartData } = useSelector((state) => state.cart);

  // useEffect(() => {
  //   if (loggedUser) {
  //     const fetchMsgCount = async () => {
  //       const msgCount = await countUnreadMessages(loggedUser.patientId);
  //       dispatch({ type: GETCOUNT, payload: msgCount });
  //     };
  //     fetchMsgCount();
  //   }
  // }, []);

  useEffect(() => {
    if (!loggedUser) return;

    const onCountChange = (size) => {
      dispatch({
        type: GETCOUNT,
        payload: size,
      });
    };

    const unsubscribe = countUnreadMessages(
      loggedUser.patientId,
      onCountChange
    );

    // VERY IMPORTANT: cleanup listener
    return () => {
      if (typeof unsubscribe === "function") {
        unsubscribe();
      }
    };
  }, [loggedUser, dispatch]);

  useEffect(() => {
    if (showDropdown) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showDropdown]);

  useEffect(() => {
    if (location.hash === "#HospitalService") {
      const procedureSection = document.getElementById("HospitalService");
      if (procedureSection) {
        procedureSection.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [location]);

  const handleClickOutside = (event) => {
    if (
      headerdropdownRef.current &&
      !headerdropdownRef.current.contains(event.target)
    ) {
      setShowDropdown(false);
    }
  };

  const handleSideMenuSignuUp = () => {
    setShowsideMenuDropdown(!showsideMenuDropdown);
  };

  const handleLoginModal = () => {
    dispatch(handleLoginSignUpModal({ data: true, actionType: LOGINMODAL }));
  };

  const handleLoginModalClose = () => {
    dispatch(handleLoginSignUpModal({ data: false, actionType: LOGINMODAL }));
  };

  const handleSignUpFromLogin = (usertype) => {
    dispatch(handleLoginSignUpModal({ data: false, actionType: LOGINMODAL }));
    dispatch(handleLoginSignUpModal({ data: true, actionType: SIGNUPMODAL }));
  };

  const handleReg = () => {
    dispatch(handleLoginSignUpModal({ data: true, actionType: SIGNUPMODAL }));
  };

  const handleRegClose = () => {
    dispatch(handleLoginSignUpModal({ data: false, actionType: SIGNUPMODAL }));
  };

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const handleRoute = (route) => {
    navigate(route);
  };

  const handleLogOut = () => {
    localStorage.clear();
    dispatch(deleteDataFromLocal());
    dispatch(clearLoggedUser(null));
    dispatch(clearSelectedAppt(null));
    handleRoute(APP_ROUTES.LOGIN);
  };

  const handleHSNavigation = () => {
    const currentPath = location.pathname;
    navigate(APP_ROUTES.HEALTHSUMMARY, {
      state: { patientId: loggedUser.patientId, path: currentPath },
    });
  };

  const handleEmgDataView = () => {
    setEmgDataModal(true);
  };

  const handleEmgClose = () => {
    setEmgDataModal(false);
  };

  const handleChatOpen = () => {
    setChatOpen(true);
  };

  const handleChatClose = () => {
    setChatOpen(false);
  };

  const menu = (
    <Menu className="w-full">
      <Menu.Item key="1" onClick={() => handleRoute(APP_ROUTES.MYPROFILE)}>
        My Profile
      </Menu.Item>
      {!loggedUser?.parentPatientId && (
        <Menu.Item
          key="2"
          onClick={() => handleRoute(APP_ROUTES.FAMILYMEMBERS)}
        >
          Family Members
        </Menu.Item>
      )}

      <Menu.Item key="3" onClick={() => handleRoute(APP_ROUTES.MYAPPOINMENTS)}>
        Appointments
      </Menu.Item>
      <Menu.SubMenu key="medicalRecords" title="Medical Records">
        <Menu.Item
          key="4-1"
          onClick={() => handleRoute(APP_ROUTES.MEDICALHISTORY)}
        >
          Medical History
        </Menu.Item>
        <Menu.Item
          key="4-2"
          onClick={() => handleRoute(APP_ROUTES.MYPRESCRIPTION)}
        >
          My Prescription
        </Menu.Item>
        <Menu.Item key="4-3" onClick={() => handleRoute(APP_ROUTES.MYREPORTS)}>
          My Reports
        </Menu.Item>
        <Menu.Item
          key="4-4"
          onClick={() => handleRoute(APP_ROUTES.MYLABREPORTS)}
        >
          Lab Reports
        </Menu.Item>
        <Menu.Item key="4-5" onClick={() => handleRoute(APP_ROUTES.MYVITALS)}>
          Vitals
        </Menu.Item>
      </Menu.SubMenu>
      <Menu.Item key="5" onClick={() => handleRoute(APP_ROUTES.PAYMENTS)}>
        Payments
      </Menu.Item>
      <Menu.Item key="11" onClick={() => handleRoute(APP_ROUTES.MEMBERSHIP)}>
        Membership
      </Menu.Item>
      <Menu.Item key="9" onClick={() => handleRoute(APP_ROUTES.ORDERHISTORY)}>
        Order History
      </Menu.Item>
      <Menu.Item key="6" onClick={() => handleRoute(APP_ROUTES.CONSENT)}>
        Consent
      </Menu.Item>

      <Menu.Item key="7" onClick={() => handleRoute(APP_ROUTES.SETTINGS)}>
        Settings
      </Menu.Item>
      {loggedUser?.rpmApplicable === "Y" && (
        <Menu.Item key="10" onClick={() => handleRoute(APP_ROUTES.DEVICES)}>
          Devices
        </Menu.Item>
      )}
      <Menu.Item
        key="11"
        onClick={() => handleRoute(APP_ROUTES.PROCEDURELIST)}
      >
        Procedure List
      </Menu.Item>
      <Menu.Item key="8" onClick={handleLogOut}>
        Logout
      </Menu.Item>
    </Menu>
  );

  useEffect(() => {
    getNotiCount();
  }, []);

  const getNotiCount = async () => {
    try {
      let countStatus = await dispatch(getNotificationCount());
    } catch (e) {
      console.error(e);
    }
  };

  return (
    <div className="w-full bg-[#189FAA] fixed z-50 top-0 py-2 px-5 h-[70px]">
      <div className="w-full flex justify-between">
        <div className="nav flex justify-between items-center text-white gap-7 ">
          {!loggedUser ? (
            <div
              className="cursor-pointer"
              onClick={() => handleRoute(APP_ROUTES.LOGIN)}
            >
              <img className="pt-1 w-32" src={doxzonLogo} alt="Logo" />
            </div>
          ) : (
            <div
              className="cursor-pointer"
              onClick={() => handleRoute(APP_ROUTES.HOME)}
            >
              <img className="pt-1 w-32" src={doxzonLogo} alt="Logo" />
            </div>
          )}
          <Link
            to={APP_ROUTES.CONSULTDOCTOR}
            className={`leading-normal hover:text-[#C1F2F5] no-underline font-inter font-medium xl:text-[17px] lg:text-[14px] cursor-pointer ${
              location.pathname === APP_ROUTES.CONSULTDOCTOR
                ? "border-b-4 border-b-white"
                : ""
            }`}
          >
            Consult Doctor
          </Link>
          <div className="flex gap-1 items-center">
            <Link
              to={APP_ROUTES.MEDICINES}
              className={`leading-normal hover:text-[#C1F2F5] no-underline font-inter font-medium xl:text-[17px] lg:text-[14px] cursor-pointer ${
                location.pathname === APP_ROUTES.MEDICINES
                  ? "border-b-4 border-b-white"
                  : ""
              }`}
            >
              Medicine
            </Link>
          </div>
          <Link
            to={APP_ROUTES.LABTESTS}
            className={`leading-normal hover:text-[#C1F2F5] no-underline font-inter font-medium xl:text-[17px] lg:text-[14px] cursor-pointer ${
              location.pathname === APP_ROUTES.LABTESTS
                ? "border-b-4 border-b-white"
                : ""
            }`}
          >
            Lab Tests
          </Link>
          <Link
            to={APP_ROUTES.HOSPITALSERVICE}
            className={`leading-normal hover:text-[#C1F2F5] no-underline font-inter font-medium xl:text-[17px] lg:text-[14px] cursor-pointer ${
              location.pathname === APP_ROUTES.HOSPITALSERVICE
                ? "border-b-4 border-b-white"
                : ""
            }`}
          >
            Procedure
          </Link>
          {/* <Link
            to={APP_ROUTES.HEALTHPLANS}
            className={`leading-normal hover:text-[#C1F2F5] no-underline font-inter font-medium xl:text-[17px] lg:text-[14px] cursor-pointer ${
              location.pathname === APP_ROUTES.HEALTHPLANS
                ? "border-b-4 border-b-white"
                : ""
            }`}
          >
            MemberShips
          </Link> */}
        </div>

        <div className="flex items-center justify-end">
          {/* Desktop Menu */}
          <ul className="nav flex items-center font-sans text-white gap-3 md:hidden sm:hidden xs:hidden m:hidden">
            {!loggedUser && (
              <Link
                to="/#providers"
                className="leading-normal hover:text-[#C1F2F5] no-underline text-[17px] cursor-pointer"
              >
                For Providers
              </Link>
            )}
            {!loggedUser && (
              <Link
                to="/#patients"
                className="leading-normal hover:text-[#C1F2F5] no-underline text-[17px] cursor-pointer"
              >
                For Patients
              </Link>
            )}
            {!loggedUser && (
              <Link
                to="/#clinic"
                className="leading-normal hover:text-[#C1F2F5] no-underline text-[17px] cursor-pointer"
              >
                For Clinic
              </Link>
            )}

            {!loggedUser ? (
              <div className="flex gap-1 items-center">
                <button
                  className="leading-normal hover:text-[#C1F2F5] no-underline text-[17px] cursor-pointer"
                  onClick={handleLoginModal}
                >
                  Login
                </button>
              </div>
            ) : (
              <div className="flex items-center gap-4">
                <Tooltip
                  title="Chats"
                  onClick={() => {
                    navigate(APP_ROUTES.NOTIFICATION);
                  }}
                >
                  <Badge className="w-6 h-6 relative cursor-pointer">
                    {notificationCount > 0 && (
                      <div className="bg-red-600 rounded-full text-white text-[10px] font-semibold text-center flex justify-center items-center max-w-max min-w-5 w-5 h-5 absolute bottom-[15px] right-[10px]">
                        {notificationCount > 99 ? "99+" : notificationCount}
                      </div>
                    )}
                    <IoIosNotifications
                      className="text-White text-lg"
                      onClick={() => {
                        navigate(APP_ROUTES.NOTIFICATION);
                      }}
                    />
                  </Badge>
                </Tooltip>
                <Tooltip title="Chats" onClick={handleChatOpen}>
                  <Badge className="w-6 h-6 relative cursor-pointer">
                    {totalnotifyCount > 0 && (
                      <div className="bg-red-600 rounded-full text-white text-[10px] font-semibold text-center flex justify-center items-center max-w-max min-w-5 w-5 h-5 absolute bottom-[15px] left-[10px]">
                        {totalnotifyCount > 99 ? "99+" : totalnotifyCount}
                      </div>
                    )}
                    <button className="w-[inherit] h-[inherit]">
                      <IoIosChatboxes className="text-White text-lg" />
                    </button>
                  </Badge>
                </Tooltip>
                <Tooltip title="Emergency Data">
                  <button onClick={handleEmgDataView}>
                    <MdContactEmergency className="text-White text-lg" />
                  </button>
                </Tooltip>
                <Tooltip title="Health Summary">
                  <button onClick={handleHSNavigation}>
                    <GiHealing className="text-White text-lg" />
                  </button>
                </Tooltip>
                <Dropdown overlay={menu} trigger={["click", "hover"]}>
                  <Avatar className="bg-White text-iconBlue text-lg font-medium cursor-pointer">
                    {loggedUser?.firstName.charAt(0)}
                  </Avatar>
                </Dropdown>
              </div>
            )}
          </ul>
          {!loggedUser ? (
            <div className="mt-1 ml-3"></div>
          ) : (
            <div className="relative">
              <div className="mt-1 ml-3 md:hidden block">
                <FaShoppingCart
                  className="text-white w-6 h-6 md:w-4 md:h-4 lg:w-4 lg:h-4  cursor-pointer"
                  onClick={() => handleRoute(APP_ROUTES.CART)}
                />
              </div>
              {loggedUser.patientId && cartData?.cartItemsCount > 0 && (
                <span className="absolute -top-1.5 -right-2.5 bg-red-500 text-white text-[8px] px-1.5 py-[2px] rounded-full">
                  {cartData?.cartItemsCount > 99
                    ? "99+"
                    : cartData?.cartItemsCount}
                </span>
              )}
            </div>
          )}
          {/* Hamburger Icon for Mobile */}
          <div className="max-lg:flex xl:hidden x:hidden l:hidden lg:hidden text-white">
            <button onClick={toggleMobileMenu}>
              {isMobileMenuOpen ? <FaTimes size={24} /> : <FaBars size={24} />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu (Sliding In) */}
      <div
        className={`fixed top-16 left-0 w-3/4 bg-[#002F72] px-5 text-white z-40 transform ${
          isMobileMenuOpen ? "translate-x-0" : "-translate-x-full"
        } transition-transform duration-300 ease-in-out lg:hidden`}
      >
        <ul className="sidemenu flex flex-col items-start font-Poppins text-white gap-6 p-6 overflow-y-auto">
          <Link
            to="/#providers"
            onClick={toggleMobileMenu}
            className="hover:text-[#C1F2F5] no-underline uppercase xl:text-[17px] lg:text-[15px]"
          >
            For Providers
          </Link>
          <Link
            to="/#patients"
            onClick={toggleMobileMenu}
            className="hover:text-[#C1F2F5] no-underline uppercase xl:text-[17px] lg:text-[15px]"
          >
            For Patients
          </Link>
          <p
            className="leading-normal hover:text-[#C1F2F5] no-underline uppercase xl:text-[17px] lg:text-[14px] cursor-pointer"
            onClick={() => handleRoute(APP_ROUTES.CONSULTDOCTOR)}
          >
            Consult Doctor
          </p>
          <Link
            to="/#clinic"
            onClick={toggleMobileMenu}
            className="hover:text-[#C1F2F5] no-underline uppercase xl:text-[17px] lg:text-[15px]"
          >
            For Clinic
          </Link>
          <div>
            <>
              {loggedUser ? (
                <div className="flex flex-col gap-6">
                  <p
                    onClick={() => handleRoute(APP_ROUTES.MYPROFILE)}
                    className="hover:text-[#C1F2F5] no-underline uppercase xl:text-[17px] lg:text-[15px]"
                  >
                    My Profile
                  </p>
                  <p
                    onClick={() => handleRoute(APP_ROUTES.CONSENT)}
                    className="hover:text-[#C1F2F5] no-underline uppercase xl:text-[17px] lg:text-[15px]"
                  >
                    Consent
                  </p>
                  <p
                    onClick={() => handleRoute(APP_ROUTES.FAMILYMEMBERS)}
                    className="hover:text-[#C1F2F5] no-underline uppercase xl:text-[17px] lg:text-[15px]"
                  >
                    Family Members
                  </p>
                  <p
                    onClick={() => handleRoute(APP_ROUTES.MYAPPOINMENTS)}
                    className="hover:text-[#C1F2F5] no-underline uppercase xl:text-[17px] lg:text-[15px]"
                  >
                    Appointments
                  </p>
                  <p className="uppercase xl:text-[17px] lg:text-[15px] hover:text-[#C1F2F5]">
                    Medical Records
                  </p>
                  <ul className="pl-4">
                    <p
                      onClick={() => handleRoute(APP_ROUTES.MEDICALHISTORY)}
                      className="hover:text-[#C1F2F5] no-underline uppercase xl:text-[17px] lg:text-[15px]"
                    >
                      Medical History
                    </p>
                    <p
                      onClick={() => handleRoute(APP_ROUTES.MYPRESCRIPTION)}
                      className="hover:text-[#C1F2F5] no-underline uppercase xl:text-[17px] lg:text-[15px]"
                    >
                      My Prescription
                    </p>
                    <p
                      onClick={() => handleRoute(APP_ROUTES.MYREPORTS)}
                      className="hover:text-[#C1F2F5] no-underline uppercase xl:text-[17px] lg:text-[15px]"
                    >
                      My Reports
                    </p>
                    <p
                      onClick={() => handleRoute(APP_ROUTES.MYLABREPORTS)}
                      className="hover:text-[#C1F2F5] no-underline uppercase xl:text-[17px] lg:text-[15px]"
                    >
                      Lab Reports
                    </p>
                    <p
                      onClick={() => handleRoute(APP_ROUTES.MYVITALS)}
                      className="hover:text-[#C1F2F5] no-underline uppercase xl:text-[17px] lg:text-[15px]"
                    >
                      Vitals
                    </p>
                  </ul>
                  <p
                    onClick={() => handleRoute(APP_ROUTES.ORDERHISTORY)}
                    className="hover:text-[#C1F2F5] no-underline uppercase xl:text-[17px] lg:text-[15px]"
                  >
                    Orders History
                  </p>
                  <p
                    onClick={() => handleRoute(APP_ROUTES.PAYMENTS)}
                    className="hover:text-[#C1F2F5] no-underline uppercase xl:text-[17px] lg:text-[15px]"
                  >
                    Settings
                  </p>
                  <p
                    onClick={() => handleRoute(APP_ROUTES.SETTINGS)}
                    className="hover:text-[#C1F2F5] no-underline uppercase xl:text-[17px] lg:text-[15px]"
                  >
                    Settings
                  </p>
                  <p
                    onClick={handleLogOut}
                    className="hover:text-[#C1F2F5] no-underline uppercase xl:text-[17px] lg:text-[15px]"
                  >
                    Logout
                  </p>
                  <p
                    onClick={handleEmgDataView}
                    className="hover:text-[#C1F2F5] no-underline uppercase xl:text-[17px] lg:text-[15px]"
                  >
                    Emergency Data
                  </p>
                  <p
                    onClick={handleHSNavigation}
                    className="hover:text-[#C1F2F5] no-underline uppercase xl:text-[17px] lg:text-[15px]"
                  >
                    Health Summary
                  </p>
                  <p
                    onClick={handleEmgDataView}
                    className="hover:text-[#C1F2F5] no-underline uppercase xl:text-[17px] lg:text-[15px]"
                  >
                    Emergency Data
                  </p>
                  <p
                    onClick={handleHSNavigation}
                    className="hover:text-[#C1F2F5] no-underline uppercase xl:text-[17px] lg:text-[15px]"
                  >
                    Health Summary
                  </p>
                </div>
              ) : (
                <>
                  <button
                    className="leading-normal hover:text-[#C1F2F5] no-underline uppercase text-[17px] cursor-pointer"
                    onClick={handleSideMenuSignuUp}
                  >
                    Sign Up
                  </button>
                  <button
                    className="leading-normal hover:text-[#C1F2F5] no-underline uppercase text-[17px] cursor-pointer"
                    onClick={handleLoginModal}
                  >
                    Login
                  </button>
                  {showsideMenuDropdown && (
                    <ul ref={sideMenudropdownRef} className="list-disc mx-6">
                      <li
                        className="leading-normal hover:text-[#C1F2F5] no-underline uppercase text-[17px] cursor-pointer"
                        onClick={handleReg}
                      >
                        Doctor
                      </li>
                      <li className="leading-normal hover:text-[#C1F2F5] no-underline uppercase text-[17px] cursor-pointer">
                        Patient
                      </li>
                    </ul>
                  )}
                </>
              )}
            </>
          </div>
        </ul>
      </div>
      {/* {!loggedUser && <MembershipSlider />} */}

      {/* doctor/patient registration */}
      <Modal
        open={regModal}
        onCancel={handleRegClose}
        destroyOnClose
        footer={[]}
        width={selectedType === "doctor" ? "60%" : "30%"}
        style={{
          height: "max-content",
          padding: "0px",
        }}
      >
        <SignUp handleRegClose={handleRegClose} />
      </Modal>

      {/* Patient Login */}
      <Modal
        open={loginModal}
        footer={[]}
        className="responsive-modal"
        onCancel={handleLoginModalClose}
        destroyOnClose
      >
        <Login
          handleLoginModal={handleLoginModalClose}
          handleSignup={handleSignUpFromLogin}
        />
      </Modal>

      {/* Emergency data view  */}
      <Modal
        open={emgDataModal}
        onCancel={handleEmgClose}
        footer={[]}
        width={450}
        destroyOnClose
      >
        <div>
          <EmergencyDataView />
        </div>
      </Modal>

      <Drawer
        closeIcon={false}
        open={chatOpen}
        destroyOnClose
        onClose={handleChatClose}
      >
        <LiveChat />
      </Drawer>
    </div>
  );
}

export default Navbar;
